import { combineReducers } from "redux";
import userState from "./user";
import vehicleState from "./expiredVehicles";
import contratcsState from "./contracts";
import employeeIdState from "./employeeId";
import CustomerIdState from "./CustomerId";
import vehicleIdState from "./vehicleId";
import individualcutomerIdState from "./individualcutomerId";
import permissionsState from "./permissions";

export default combineReducers({
  userState,
  vehicleState,
  contratcsState,
  employeeIdState,
  CustomerIdState,
  vehicleIdState,
  individualcutomerIdState,
  permissionsState,
});
